/* app/js/src/components/media-transcoder/jobs/active/active.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.active-jobs-container .filters-bar .name-filter-input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.active-jobs-container .filters-bar .name-filter-input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.active-jobs-container .filters-bar .name-filter-input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.active-jobs-container .filters-bar .name-filter-input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.active-jobs-container .filters-bar .name-filter-input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.active-jobs-container .filters-bar .name-filter-input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.active-jobs-container .filters-bar .ng-invalid.ng-dirty.name-filter-input,
.active-jobs-container .filters-bar .ng-invalid.ng-touched.name-filter-input {
  border-color: #ef5350;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  display: block;
  position: relative;
  min-height: 180px;
}
.active-jobs-container {
  position: relative;
  margin-top: 1vw;
}
.active-jobs-container .filters-bar {
  align-items: center;
  gap: 1.5vw;
  margin-bottom: 1vw;
  flex-wrap: wrap;
}
.active-jobs-container .filters-bar .filter-group {
  display: flex;
  align-items: center;
  gap: 0.75vw;
  flex: 0 0 auto;
}
.active-jobs-container .filters-bar .filter-label {
  color: #232f3a;
  font-weight: 600;
  flex: 0 0 auto;
  line-height: 30px;
}
.active-jobs-container .filters-bar .name-filter-input {
  width: 14rem;
  min-width: 14rem;
  height: 30px;
  box-sizing: border-box;
  margin: 0;
  line-height: 30px;
  padding: 0 15px;
}
.active-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown {
  display: inline-block;
  width: 14rem !important;
  min-width: 14rem;
  height: 30px !important;
  vertical-align: middle;
}
.active-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown .main-container {
  height: 100%;
}
.active-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown .selected-container {
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
}
.active-jobs-container .grouped-jobs-summary {
  position: relative;
  z-index: 10;
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.active-jobs-container .grouped-jobs-summary .summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}
.active-jobs-container .grouped-jobs-summary .summary-header .summary-title {
  margin: 0;
  color: #232f3a;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}
.active-jobs-container .grouped-jobs-summary .summary-header .summary-title:hover {
  background-color: #e9ecef;
}
.active-jobs-container .grouped-jobs-summary .summary-header .summary-title .summary-counts {
  font-size: 0.9rem;
  font-weight: 400;
  color: #6c757d;
}
.active-jobs-container .grouped-jobs-summary .summary-header .collapse-icon {
  font-size: 0.8rem;
  color: #6c757d;
  margin-right: 5px;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  border-radius: 6px;
  transition: transform 0.3s ease, background-color 0.2s ease;
}
.active-jobs-container .grouped-jobs-summary .summary-header .collapse-icon:hover {
  background-color: #e9ecef;
}
.active-jobs-container .grouped-jobs-summary .summary-header .collapse-icon.collapsed {
  transform: rotate(-90deg);
}
.active-jobs-container .grouped-jobs-summary .media-groups {
  position: relative;
  z-index: 1;
  margin: 1rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  max-height: 500px;
  overflow-y: auto;
  pointer-events: auto;
}
.active-jobs-container .grouped-jobs-summary .media-groups.collapsed {
  display: none;
  margin: 0;
  pointer-events: none;
}
.active-jobs-container .grouped-jobs-summary .media-groups .media-group {
  position: relative;
  z-index: 1;
  pointer-events: auto;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease;
  cursor: pointer;
}
.active-jobs-container .grouped-jobs-summary .media-groups .media-group:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.active-jobs-container .grouped-jobs-summary .media-groups .media-group.selected {
  border-color: #40c4ff;
  background-color: #e8f7ff;
  box-shadow: 0 2px 6px rgba(64, 196, 255, 0.25);
}
.active-jobs-container .grouped-jobs-summary .media-groups .media-group .media-info {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  gap: 0.5rem;
}
.active-jobs-container .grouped-jobs-summary .media-groups .media-group .media-info .media-name {
  font-weight: 500;
  color: #232f3a;
}
.active-jobs-container .grouped-jobs-summary .media-groups .media-group .media-info .job-count {
  color: #6c757d;
  font-size: 0.9rem;
  background-color: #e9ecef;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-weight: 500;
}
.active-jobs-container .recording-history-grid {
  height: calc(80vh - 30px);
}
.active-jobs-container .recording-history-grid ::ng-deep .recording-status > span {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.active-jobs-container .recording-history-grid ::ng-deep .recording-status > span img {
  width: 17px;
  height: 17px;
}
.jobs-table {
  position: relative;
  z-index: 0;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  color: #232f3a;
}
.jobs-table tr {
  cursor: pointer;
}
.jobs-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.jobs-table tbody tr:hover {
  background-color: #e7dfdf;
}
.jobs-table th {
  border-bottom: 1px solid #232f3a;
}
.jobs-table th,
.jobs-table td {
  height: 2vw;
  padding: 0 0.75vw;
  text-align: left;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}
.jobs-table th:nth-child(1),
.jobs-table td:nth-child(1) {
  width: 28%;
  word-break: break-word;
  white-space: normal;
}
.jobs-table th:nth-child(4),
.jobs-table td:nth-child(4) {
  width: 14%;
  min-width: 8rem;
  white-space: normal;
  word-break: break-word;
}
.jobs-table .status-cell {
  color: #232f3a;
  cursor: default;
}
.jobs-table .actions-cell > a {
  position: relative;
  z-index: 1;
}
.jobs-table td > span.Low {
  color: #4472c1;
}
.jobs-table td > span.Medium {
  color: #f5d7ac;
}
.jobs-table td > span.High {
  color: #c49c9e;
}
.jobs-table td > a,
.jobs-table .actions-cell > span {
  color: #40c4ff;
  text-decoration: none;
}
.jobs-table td > a:hover,
.jobs-table .actions-cell > span:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=active.component.css.map */
